<template>
  <div class="measure-card">
    <div class="measure-header" @click="toggleFilters">
      <h4 class="title ellipsis">{{ data.name }}</h4>
      <expand />
      <Icon
        v-if="isEditable"
        :class="['delete-icon']"
        type="button"
        size="18"
        @click="deleteFilter"
        >delete</Icon
      >
      <Icon
        :class="[
          'lock-icon',
          ,
          { locked: data.isLocked },
          { disable: !isEditable },
        ]"
        type="button"
        size="18"
        @click="$emit('toggleLock')"
        >lock</Icon
      >
      <Icon
        :class="[{ rotate: showFilters }]"
        type="button"
        size="24"
        @click="toggleFilters()"
        >keyboard_arrow_down</Icon
      >
    </div>
    <transition name="slide">
      <div v-if="showFilters" class="options">
        <div class="condition-row">
          <span class="chit" v-for="chit in data.chits" :key="chit">
            <i class="material-icons md-18">lock</i>
            {{ chit }}
          </span>
        </div>
        <SimpleCategoryWidget
          v-model="filterValues"
          :disabled="false"
          :active="true"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import SimpleCategoryWidget from "@/components/global/views/SimpleCategoryWidget";
import { ActiveCategory } from "@/models/Categorical.model";
import { mapActions } from "vuex";

export default {
  props: {
    data: Object,
    isEditable: Boolean,
  },
  components: {
    SimpleCategoryWidget,
  },
  computed: {
    filterValues: {
      get() {
        return this.data.data;
      },
      set(value) {
        // if (!this.data.isLocked) {
        //   const categoricalItem = new ActiveCategory({
        //     name: this.data.name,
        //     category_id: this.data.id,
        //     item_id: value.item_id,
        //     entity_model_id: this.data.meta.id
        //   });
        //   this.$emit("toggleFilter", categoricalItem);
        // }
      },
    },
  },
  data() {
    return {
      showFilters: false,
    };
  },
  methods: {
    ...mapActions("FilterManager", ["removeCustomFilter"]),
    toggleFilters() {
      this.showFilters = !this.showFilters;
    },
    deleteFilter() {
      this.removeCustomFilter(this.data).then(() => {
        // this is odd, emit doesn't work inside this
      });
      this.$emit("toggleFilter", null);
    },
  },
};
</script>

<style lang="scss" scoped>
.measure-card {
  display: flex;
  flex-direction: column;
  background-color: var(--color-secondary);
  border-radius: 3px;
  margin: 5px 10px 10px 10px;

  .measure-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 10px 5px 15px;
    border-radius: 3px;

    .title {
      color: var(--color-primary);
    }

    i {
      margin: 0 5px 0 0;
    }

    .rotate {
      transform: rotate(180deg);
    }

    .lock-icon {
      opacity: 0.3;
      color: var(--font-color);
    }
    .locked {
      opacity: 1;
      color: var(--color-primary);
    }

    &:hover {
      background: var(--border-color);
      cursor: pointer;
    }
  }

  .condition-row {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 15px;

    .chit {
      background: var(--color-primary-light);
      color: var(--color-primary);
      padding: 5px 10px;
      border-radius: 5px;
      display: flex;
      align-items: center;

      i {
        margin-right: 5px;
      }
    }
  }

  .disable {
    pointer-events: none;
  }

  .options {
    border-top: 1px solid var(--border-color);
  }
}
</style>
